import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import AuthenticatedLayout from './components/AuthenticatedLayout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import HandbookPage from './pages/HandbookPage';
import CodeOfConductPage from './pages/CodeOfConductPage';
import SchedulePage from './pages/SchedulePage';
import GamesPage from './pages/GamesPage';
import CheckinPage from './pages/CheckinPage';
import RosterPage from './pages/RosterPage';
import AdminEventsPage from './pages/AdminEventsPage';
import AdminEventDetailPage from './pages/AdminEventDetailPage';
import AdminRosterPage from './pages/AdminRosterPage';
import AdminTeamsPage from './pages/AdminTeamsPage';
import AdminDiscordPage from './pages/AdminDiscordPage';
import ChampionshipsPage from './pages/ChampionshipsPage';
import RecordsPage from './pages/RecordsPage';
import AdminRecordsPage from './pages/AdminRecordsPage';
import AdminPermissionSlipsPage from './pages/AdminPermissionSlipsPage';
import AdminDocumentsPage from './pages/AdminDocumentsPage';
import SignupsPage from './pages/SignupsPage';
import TrophyGalleryPage from './pages/TrophyGalleryPage';
import ParentsGuidePage from './pages/ParentsGuidePage';
import ParentsGuideGamePage from './pages/ParentsGuideGamePage';
import PlayerTechniquesPage from './pages/PlayerTechniquesPage';
import PlayerDashboardPage from './pages/PlayerDashboardPage';
import PlayerEventDashboard from './pages/PlayerEventDashboard';
import PlayerProfilePage from './pages/PlayerProfilePage';
import LadderPage from './pages/LadderPage';
import PlayerLadderPage from './pages/PlayerLadderPage';
import AdminLadderPage from './pages/AdminLadderPage';
import AdminVodsPage from './pages/AdminVodsPage';
import AdminOpponentsPage from './pages/AdminOpponentsPage';
import StudentOnboardingPage from './pages/StudentOnboardingPage';
import ReportBugPage from './pages/ReportBugPage';
import AdminBugReportsPage from './pages/AdminBugReportsPage';
import { useDocumentTitle } from './hooks/useDocumentTitle';
// Broadcasting Overlay System Components
import BroadcasterLayout from './pages/broadcaster/BroadcasterLayout';
import ControlCenterPrototype from './pages/broadcaster/ControlCenterPrototype';

// Wrapper component to use hooks inside router context
function AppRoutes() {
    // Set document title for accessibility (WCAG 2.4.2)
    useDocumentTitle();

    return (
        <Routes>
            {/* Public routes with top navbar */}
            <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="signups" element={<SignupsPage />} />
                <Route path="roster" element={<RosterPage />} />
                <Route path="trophies" element={<TrophyGalleryPage />} />
                <Route path="handbook" element={<HandbookPage />} />
                <Route path="conduct" element={<CodeOfConductPage />} />
                <Route path="schedule" element={<SchedulePage />} />
                <Route path="games" element={<GamesPage />} />
                <Route path="championships" element={<ChampionshipsPage />} />
                <Route path="records" element={<RecordsPage />} />
                <Route path="ladder" element={<LadderPage />} />
                <Route path="parents" element={<ParentsGuidePage />} />
                <Route path="parents/:gameId" element={<ParentsGuideGamePage />} />
                <Route path="onboarding" element={<StudentOnboardingPage />} />
            </Route>

            {/* Authenticated routes with sidebar */}
            <Route path="/app" element={<AuthenticatedLayout />}>
                <Route index element={<DashboardPage />} />
                <Route path="player" element={<PlayerDashboardPage />} />
                <Route path="player/event/:eventId" element={<PlayerEventDashboard />} />
                <Route path="player/:playerId" element={<PlayerProfilePage />} />
                <Route path="ladder" element={<PlayerLadderPage />} />
                <Route path="techniques" element={<PlayerTechniquesPage />} />
                <Route path="report-bug" element={<ReportBugPage />} />

                {/* Admin routes */}
                <Route path="admin">
                    <Route index element={<Navigate to="events" replace />} />
                    <Route path="events" element={<AdminEventsPage />} />
                    <Route path="events/:eventId" element={<AdminEventDetailPage />} />
                    <Route path="teams" element={<AdminTeamsPage />} />
                    <Route path="roster" element={<AdminRosterPage />} />
                    <Route path="discord" element={<AdminDiscordPage />} />
                    <Route path="records" element={<AdminRecordsPage />} />
                    <Route path="permission-slips" element={<AdminPermissionSlipsPage />} />
                    <Route path="documents" element={<AdminDocumentsPage />} />
                    <Route path="ladder" element={<AdminLadderPage />} />
                    <Route path="vods" element={<AdminVodsPage />} />
                    <Route path="opponents" element={<AdminOpponentsPage />} />
                    <Route path="bug-reports" element={<AdminBugReportsPage />} />
                </Route>
            </Route>

            {/* Redirect old routes to new routes */}
            <Route path="/admin/*" element={<Navigate to="/app/admin" replace />} />
            <Route path="/dashboard" element={<Navigate to="/app" replace />} />

            {/* Public Check-in (outside Layout for kiosk mode) */}
            <Route path="checkin/:eventId" element={<CheckinPage />} />

            {/* Broadcaster Control Center (New Feature Prototype) */}
            <Route path="/broadcaster" element={<BroadcasterLayout />}>
                <Route index element={<ControlCenterPrototype />} />
                {/* Future routes for Assets/Scouting will go here */}
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;

